var App = (function () {
  'use strict';

  App.ajaxForm = function( ){
    var form = $('.js-ajax-form');

    $(form).submit(function(event) {
      event.preventDefault();

      var $form = $(this);

      var formData = $form.serialize();
      var timerInMs = 1500;
      var submitButton = $form.closest('form').find(':submit');

      enableLoading();

      $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: formData,
        beforeSend: function() {
          enableLoading();
        }
      }).done(function(response) {
        $form.trigger('success');

        swal({
          type: response.swal.type,
          title: response.swal.title,
          showConfirmButton: false,
          timer: timerInMs,
          customClass: 'content-header-center'
        }).then(function() {
          if (response.url) {
            window.location = response.url;
          }
          if (response.reload) {
            document.location.reload();
          }
        });

      }).fail(function(data) {
        $form.trigger('fail');
        swal({
          type: 'error',
          title: 'Ошибка подключения',
          showConfirmButton: false,
          timer: timerInMs,
          customClass: 'content-header-center'
        });

        //disableLoading();
      }).always(function() {
        disableLoading();
      });

      function enableLoading() {
        submitButton.prop('disabled', true);
        submitButton.fadeTo(300, 0.3);

        $('.be-loading').addClass('be-loading-active');
      }

      function disableLoading() {
        submitButton.prop('disabled', false);
        submitButton.fadeTo(300, 1);

        $('.be-loading').removeClass('be-loading-active');
      }

    });

  };

  return App;
})(App || {});
